// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import CreateAlertImportanceSelectorTemplate from '@front/templates/CreateAlertImportanceSelectorTemplate.html';
import { ContainerControl } from '../../elements/ContainerControl';
import { Resources } from '@shared/localizations/Resources';
import { AlertImportance, getAlertImportanceKey } from '@shared/utils/Alert/AlertConstants';
import { ResourcesManager } from '@shared/commons/properties/ResourcesManager';
import { createContextMenuItemsFromEnum } from '@shared/utils/ContextMenuUtils';
export class CreateAlertImportanceSelector extends ContainerControl {
    constructor() {
        super();
    }
    getType() {
        return 'CreateAlertImportanceSelector';
    }
    oninit() {
        super.oninit();
        this.repopulate();
        this.observe('selectedItem', this.updateAlertImportance);
        this.observe('value', this.updateAlertImportanceValue);
        ResourcesManager.onLocaleChange.Subscribe(this.localize, this);
        this.localize();
    }
    updateAlertImportance(selectedItem) {
        if (!isNullOrUndefined(selectedItem)) {
            void this.set({ value: selectedItem.value });
        }
    }
    updateAlertImportanceValue(newV, oldV) {
        const items = this.get('items');
        if (!isValidArray(items)) {
            return;
        }
        for (let i = 0; i < items.length; i++) {
            if (items[i].value === newV) {
                void this.set({ selectedItem: items[i] });
                break;
            }
        }
    }
    dispose() {
        ResourcesManager.onLocaleChange.UnSubscribe(this.localize, this);
        super.dispose();
    }
    repopulate() {
        const items = this.get('items');
        const selectedItem = items.find((item) => item.value === AlertImportance.MEDIUM);
        void this.set({ selectedItem });
    }
    localize() {
        void this.set('label', Resources.getResource('screen.Alerts.Label.Importance'));
    }
}
ContainerControl.extendWith(CreateAlertImportanceSelector, {
    template: CreateAlertImportanceSelectorTemplate,
    data: function () {
        return {
            label: '',
            instrument: null,
            items: createContextMenuItemsFromEnum(AlertImportance, getAlertImportanceKey),
            selectedItem: null,
            width: 198
        };
    }
});
